import $ from 'jquery';

$(document).ready(() => {
  const $caseStudyCarousel = $('.js-case-study-carousel');

  if (!$caseStudyCarousel.length) {
    return;
  }

  require.ensure(['slick-carousel/slick/slick'], (require) => {
    require('slick-carousel/slick/slick');

    $caseStudyCarousel.slick({
      dots: false,
      autoplay: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      // eslint-disable-next-line max-len
      prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button"><div class="svg-bg"></div><span class="visuallyhidden">Previous</span></button>',
      // eslint-disable-next-line max-len
      nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button"><div class="svg-bg"></div><span class="visuallyhidden">Next</span></button>',
    });
  });
});
